import contracts from 'config/constants/contracts'
import { getAddress } from './addressHelpers'

enum CHAIN_TYPE_MINTED {
  CRONOS = 'cronos',
}

export const getVVSMinerMoleMintedUrl = (tokenId?: string | number) => {
  if (tokenId !== undefined) {
    return `${process.env.REACT_APP_MINTED_URL}/${CHAIN_TYPE_MINTED.CRONOS}/${getAddress(contracts.vvsMole)}/${tokenId}`
  }

  return `${process.env.REACT_APP_MINTED_URL}/${CHAIN_TYPE_MINTED.CRONOS}/${getAddress(contracts.vvsMole)}`
}

export const getArgoMintedUrl = () => {
  return `${process.env.REACT_APP_MINTED_URL}/${CHAIN_TYPE_MINTED.CRONOS}/${getAddress(contracts.argoNftCollection)}`
}
